export const MODULE_NAME = 'order';

const prefix = `${MODULE_NAME}/`;

export const ACTION_TYPES = {
    SESSION_ERROR_FETCHED: `${prefix}SESSION_ERROR_FETCHED`,
    ORDER_POSITION_ADDED: `${prefix}ORDER_POSITION_ADDED`,
    ADD_ORDER_POSITION_FAILED: `${prefix}ADD_ORDER_POSITION_FAILED`,
    CLEAR_ADD_ORDER_POSITION_ERROR_MESSAGE: `${prefix}CLEAR_ADD_ORDER_POSITION_ERROR_MESSAGE`,
    ORDERS_FETCHED: `${prefix}ORDERS_FETCHED`,
    BILL_FETCHED: `${prefix}BILL_FETCHED`,
    INCREASE_QUANTITY: `${prefix}INCREASE_QUANTITY`,
    DECREASE_QUANTITY: `${prefix}DECREASE_QUANTITY`,
    SET_SELECTED_MENU_POSITION: `${prefix}SET_SELECTED_MENU_POSITION`,
    SELECTED_MENU_POSITION_CLEARED: `${prefix}SELECTED_MENU_POSITION_CLEARED`,
    SUBMIT_ORDER_SUCCESS: `${prefix}SUBMIT_ORDER_SUCCESS`,
    SUBMIT_ORDER_FAILED: `${prefix}SUBMIT_ORDER_FAILED`,
    SUBMIT_ORDER_PENDING: `${prefix}SUBMIT_ORDER_PENDING`,
    SUBMIT_ASK_FOR_BILL_FAILED: `${prefix}SUBMIT_ASK_FOR_BILL_FAILED`,
    SUBMIT_ASK_FOR_BILL: `${prefix}SUBMIT_ASK_FOR_BILL`,
    CLEAR_SUBMIT_ORDER_ERROR: `${prefix}CLEAR_SUBMIT_ORDER_ERROR`,
    ASKED_FOR_BILL: `${prefix}ASKED_FOR_BILL`,
    SET_ADDON_AS_SELECTED: `${prefix}SET_ADDON_AS_SELECTED`,
    SET_ADDON_AS_UNSELECTED: `${prefix}SET_ADDON_AS_UNSELECTED`,
    ADD_ADDON: `${prefix}ADD_ADDON`,
    REMOVE_ADDON: `${prefix}REMOVE_ADDON`,
    ORDER_POSITION_VALIDATED: `${prefix}ORDER_POSITION_VALIDATED`,
    REMOVE_ORDER_POSITION: `${prefix}REMOVE_ORDER_POSITION`,
    REMOVE_ORDER_POSITION_FAILED: `${prefix}REMOVE_ORDER_POSITION_FAILED`,
    COMMENT_CHANGED: `${prefix}COMMENT_CHANGED`,
    CHANGE_QUANTITY_ORDER_POSITION: `${prefix}CHANGE_QUANTITY_ORDER_POSITION`,
    CHANGE_QUANTITY_ORDER_POSITION_FAILED: `${prefix}CHANGE_QUANTITY_ORDER_POSITION_FAILED`,
    ORDER_CANCELLED: `${prefix}ORDER_CANCELLED`,
    CANCEL_ORDER_FAILED: `${prefix}CANCEL_ORDER_FAILED`,
    REPAYMENT_SUCCESS: `${prefix}REPAYMENT_SUCCESS`,
    REPAYMENT_FAILED: `${prefix}REPAYMENT_FAILED`,
    CLEAR_CANCEL_ORDER_ERROR: `${prefix}CLEAR_CANCEL_ORDER_ERROR`,
    CLEAR_REPAYMENT_ERROR: `${prefix}CLEAR_REPAYMENT_ERROR`,
    CLEAR_ASK_FOR_BILL_ERROR: `${prefix}CLEAR_ASK_FOR_BILL_ERROR`
};

export const ORDER_STATUS = {
    NEW: 0,
    PLACED: 1,
    ACCEPTED: 2,
    COMPLETED: 3
};

export const BILL_STATUS = {
    OPEN: 0,
    CLOSED: 1,
    PAID: 2,
    PAYMENT_ERROR: 3,
    ABORTED: 4
};

export const BILL_TILE_TYPE = {
    ORDER: 0,
    SUMMARY: 1
};

export const PAYMENT_METHOD = {
    TERMINAL: 0,
    CASH: 1
};
